import { useNavigate } from 'react-router-dom'
import { useAuth } from '../context/AuthContext'
import GettingStarted from '../help/GettingStarted'

function HomePage() {
  const { user, logout } = useAuth()
  const navigate = useNavigate()

  const handleLogout = async () => {
    await logout()
    navigate('/')
  }

  const wrap = { padding: '2rem', fontFamily: 'system-ui, sans-serif', maxWidth: 640 }
  const section = { marginTop: '1rem' }

  return (
    <main style={wrap}>
      <GettingStarted />
      <h1>Welcome, {user?.displayName || user?.email}</h1>
      <p style={{ color: '#707070' }}>{user?.occupation}</p>

      <div style={section}>
        <strong>Company:</strong> {user?.company || '—'}
        <br />
        <strong>Location:</strong> {user?.location || '—'}
      </div>

      {user?.bio && (
        <div style={section}>
          <strong>Bio</strong>
          <p>{user.bio}</p>
        </div>
      )}

      <div style={section}>
        <strong>Education</strong>
        {user?.education?.length ? (
          <ul>
            {user.education.map((entry, index) => (
              <li key={index}>
                {entry.school} {entry.major && `— ${entry.major}`} ({entry.startYear || '?'}–
                {entry.current ? 'present' : entry.endYear || '?'})
              </li>
            ))}
          </ul>
        ) : (
          <p>None added</p>
        )}
      </div>

      <div style={section}>
        <strong>Experience</strong>
        {user?.experience?.length ? (
          <ul>
            {user.experience.map((entry, index) => (
              <li key={index}>
                {entry.title && `${entry.title} @ `}
                {entry.company} ({entry.startYear || '?'}–
                {entry.current ? 'present' : entry.endYear || '?'})
              </li>
            ))}
          </ul>
        ) : (
          <p>None added</p>
        )}
      </div>

      <button style={{ marginTop: '1.5rem' }} onClick={handleLogout}>
        Log out
      </button>
    </main>
  )
}

export default HomePage
